import React from 'react';
import PropTypes from 'prop-types';
import ColourWidget from '@components/search_filters/units/colourWidget';

const ColourTabs = ({ groups, activeTab, setActiveTab }) => {
  return (
    <div className="ch-bb--1 ch-bc--grey-3 ch-tab__wrapper js-off--hide">
      {Object.keys(groups).map((colour) => (
        <button
          className={`ch-tab ch-display--flex ch-align-items--center ${
            activeTab === colour ? 'ch-tab--selected' : ''
          }`}
          data-gtm-track="interaction"
          data-gtm-track-action="Online showroom"
          data-gtm-track-label={`Clicked colour tab - ${colour}`}
          key={colour}
          onClick={() => setActiveTab(colour)}
          type="button"
        >
          {colour !== 'All Colours' && <ColourWidget colour={colour} />}
          {`${colour} (${groups[colour].count})`}
        </button>
      ))}
    </div>
  );
};

export default ColourTabs;

ColourTabs.propTypes = {
  activeTab: PropTypes.string,
  groups: PropTypes.object,
  setActiveTab: PropTypes.func,
};
